import { Avatar, Button, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import { Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import WithAuth from "../../hoc/withAuth";
import { useSeller } from "../../hooks/useSeller";
import { useImport } from "../../hooks/useImport";
import { Alert } from "../../components/Alert";
import { showToast } from "../../utils";

interface ErrorsApiProps {
  code: string;
  description: string;
  title: string;
}

const ImportarAssinatura = () => {
  let { id } = useParams();
  const { Dragger } = Upload;
  const [file, setFile] = useState<File | null>();
  const [filesList, setFilesList] = useState<any>();
  const [status, setStatus] = useState("");
  const [errors, setErros] = useState<ErrorsApiProps[]>([]);
  const [isAlertFileExtensionWrong, setIsAlertFileExtensionWrong] = useState(false);
  const [disableButtonImport, setDisableButtonImport] = useState(false);
  const { seller, getSellerData } = useSeller();
  const { postImportCsv } = useImport();

  useEffect(() => {
    getSellerData(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  async function handleImportCsv() {
    if (disableButtonImport) return;
    setDisableButtonImport(true);
    if (file) {
      let fileExtension = file.name.split(".")[1];
      if (fileExtension !== "csv") {
        setErros([
          {
            code: "403",
            description: "Extensao do arquivo nao suportada.",
            title: "",
          },
        ]);
        setFile(null);
        setFilesList(null);
        setDisableButtonImport(false);
        return;
      }
      try {
        setErros([]);
        setStatus("");
        await postImportCsv(file, id);
        setStatus("success");
      } catch (error: any) {
        error?.response?.data?.errors?.map((error:any) => (
          showToast({
            type: "error",
            message: `${error?.code} - ${error?.description}`
          })
        ));
        const err = error as AxiosError;
        setErros(err?.response?.data?.errors);
      }
    }
    setFile(null);
    setFilesList(null);
    setDisableButtonImport(false);
  }
  const props = {
    accept: ".csv",
    onRemove: () => {
      setFile(null);
      setFilesList(null);
    },
    beforeUpload: (file: any) => {
      setFile(file);
      return false;
    },
    fileList: filesList,
    file,
  };
  return (
    <Flex p="10" direction="column" gap={8}>
      <Alert
        isOpen={isAlertFileExtensionWrong}
        onClose={() => setIsAlertFileExtensionWrong(false)}
        title="Erro"
        messageBody="Formato de extensao nao permitido"
        onConfirm={() => setIsAlertFileExtensionWrong(false)}
        leastDestructiveRef
      />
      <Breadcrumb
        previous_page_link={`/seller/${id}`}
        previous_page={seller.companyName}
        current_page="Importar"
      />
      {/** Header */}
      <Flex
        w="100%"
        borderTop="1px solid #DFE3EC"
        borderBottom="1px solid #DFE3EC"
        py="1.5rem"
        align="center"
        gap={8}
      >
        <Avatar
          w="80px"
          h="80px"
          borderRadius="8px"
          src={seller.icon}
          name={seller.fantasyName}
        />
        <Heading fontSize="24px">{seller.fantasyName}</Heading>
      </Flex>

      <Flex w="100%" justify="center" mt="8">
        <Stack gap={8}>
          <Heading fontSize="18px">Importar assinaturas</Heading>
          <Dragger {...props} maxCount={1}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Clique ou arraste o arquivo para esta área para carregar o seu
              arquivo
            </p>
            <p className="ant-upload-hint">
              O arquivo deve estar em formato .CSV{" "}
            </p>
          </Dragger>
          <Button
            variant="primary"
            disabled={disableButtonImport}
            onClick={handleImportCsv}
          >
            {` Importar `}
          </Button>
        </Stack>
      </Flex>

      <Heading fontSize="18px">Relatorio</Heading>
      <Flex w="100%" bgColor="#FAFAFA" p={8} direction="column">
        {errors?.length > 0 && (
          <Stack>
            <Text color="#8E1E1E">Errors: </Text>
            {errors.map((error) => (
              <Text key={error.code} color="#8E1E1E">
                - {error.description}
              </Text>
            ))}
          </Stack>
        )}
        {status === "success" && (
          <Text>- Importação realizada com sucesso! ✅</Text>
        )}
      </Flex>
    </Flex>
  );
};

export default WithAuth(ImportarAssinatura);
